module.exports = __webpack_public_path__ + "img/3B.6ce27b5a.jpeg";